        <!-- Pricing Details -->
        <div *appHasRole="[4,6]" class="w-full flex flex-col gap-y-2">
            <div class="flex flex-row items-center gap-x-4 w-full py-2">
                <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Pricing Details</h2>
                <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
                <button (click)="expandPricingDetails.set(!expandPricingDetails())" type="button"
                    class="btn-fab-primary">
                    @if (expandPricingDetails()) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m18 15-6-6-6 6" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                    }
                </button>
            </div>
            @if (expandPricingDetails()) {
            <div class="grid gap-x-4" [class.grid-cols-2]="!showPricingDetailsThirdColumn()"
                [class.grid-cols-3]="showPricingDetailsThirdColumn()">
                <article class="divide-y divide-gray-200 overflow-hidden dark:divide-white/10 briefing-section-card">
                    <div class="px-2 pb-2">
                        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                            <div class="">
                                <h3 class="text-base font-semibold text-gray-900 dark:text-white">Pricing Model</h3>
                                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">Active pricing model for this
                                    brief.</p>
                            </div>
                            <div class="shrink-0">
                                <button (click)="copyPricingModelId()" type="button" class="btn-fab-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="p-2 isolate flex flex-col">
                        @if (manageBriefTabsService.focussedBrief()!.basePricingModel) {
                        <pre><code>{{ manageBriefTabsService.focussedBrief()!.basePricingModel | json }}</code></pre>
                        }
                    </div>
                </article>

                <article *appHasRole="[77]"
                    class="divide-y divide-gray-200 overflow-hidden dark:divide-white/10 briefing-section-card">
                    <div class="px-2 pb-2">
                        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                            <div class="">
                                <h3 class="text-base font-semibold text-gray-900 dark:text-white">Current Price</h3>
                                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">The current selections deciding
                                    the earnings.</p>
                            </div>
                            <div class="shrink-0">
                                <button (click)="copyCurrentPriceId()" type="button" class="btn-fab-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="p-2 isolate flex flex-col">
                        @if (manageBriefTabsService.focussedBrief()!.currentPrice) {
                        <pre><code>{{ manageBriefTabsService.focussedBrief()!.currentPrice | json }}</code></pre>
                        }
                    </div>
                </article>

                <article class="divide-y divide-gray-200 overflow-hidden dark:divide-white/10 briefing-section-card">
                    <div class="px-2 pb-2">
                        <div class="flex flex-wrap items-center justify-between sm:flex-nowrap">
                            <div class="">
                                <h3 class="text-base font-semibold text-gray-900 dark:text-white">Calculations</h3>
                                <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">How are the values calculated?
                                    (per video)
                                </p>
                            </div>
                            <div class="shrink-0">
                                <button (click)="copyCurrentPriceId()" type="button" class="btn-fab-primary">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5">
                                        <rect width="14" height="14" x="8" y="8" rx="2" ry="2" />
                                        <path d="M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="py-2 isolate flex flex-col gap-y-4">
                        <ul role="list"
                            class="divide-y divide-gray-100 dark:divide-white/5 p-2 rounded-md bg-indigo-50 dark:bg-indigo-800">
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        🤦
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">Face Price</p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('facePrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.facePrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        📹
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">UGC Price</p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('ugcPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.ugcPrice / 100 | currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        🏷️
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">Ad Price</p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('advertisingPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.advertisingPrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        🚀
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">Social Post
                                            Price</p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('socialPostPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.socialPostPrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        15
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">15 Sec Price
                                        </p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('fifteenSecPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.fifteenSecPrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        30
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">30 Sec Price
                                        </p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('thirtySecPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.thirtySecPrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        60
                                    </div>
                                    <div class="min-w-0 flex-col items-center">
                                        <p class="text-sm/6 font-semibold text-gray-900 dark:text-white">60 Sec Price
                                        </p>
                                    </div>
                                </div>
                                <div class="hidden shrink-0 sm:flex sm:flex-col sm:items-end">
                                    <p
                                        [class]="rateUsed('sixtySecPrice') ? 'text-emerald-600 text-md font-medium': 'text-primary text-sm/6'">
                                        {{
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.sixtySecPrice / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                </div>
                            </li>

                            <!-- Base Price Blue Box -->
                            <div
                                class="mt-1 rounded-md bg-blue-50 p-4 dark:bg-blue-500/10 dark:outline dark:outline-blue-500/20">
                                <div class="flex">
                                    <div class="shrink-0">
                                        <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                            class="size-5 text-blue-400">
                                            <path
                                                d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                    </div>
                                    <div class="ml-3 flex-1 md:flex md:justify-between">
                                        <p class="text-sm text-blue-700 dark:text-blue-300">Base Price (per video)</p>
                                        <p class="mt-3 text-sm md:mt-0 md:ml-6">
                                            <a
                                                class="font-medium whitespace-nowrap text-blue-700 hover:text-blue-600 dark:text-blue-300 dark:hover:text-blue-200">
                                                @let calcRange = basePriceRange();
                                                {{ calcRange.min | currency:
                                                manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                                }}@if (calcRange.max !== calcRange.min) { – {{ calcRange.max | currency:
                                                manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                                }} }

                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <!-- Base Price Blue Box - END -->
                        </ul>

                        <ul role="list"
                            class="mt-6 divide-y divide-gray-100 dark:divide-white/5 p-2 rounded-md bg-indigo-50 dark:bg-indigo-800">
                            @for (level of manageBriefTabsService.focussedBrief()!.currentPrice?.influencerLevels;
                            track $index) {
                            <li class="flex items-center justify-between gap-x-6 py-2">
                                <div class="flex flex-row items-center min-w-0 gap-x-4">
                                    <div
                                        class="flex items-center justify-center size-12 rounded-full bg-gray-50 dark:bg-gray-800">
                                        ⚡️
                                    </div>
                                    <div class="min-w-0 flex-auto">
                                        <p class="text-sm/6 font-semibold text-primary">{{ level.title }}</p>
                                        <p class="text-xs/5 text-secondary">{{
                                            formatService.convertIntToString(level.followersFrom) }} to {{
                                            formatService.convertIntToString(level.followersTo) }} followers</p>
                                    </div>
                                </div>
                                <div class="shrink-0 flex flex-col items-end">
                                    <p class="text-sm/6 text-primary">+ {{
                                        level.bonusValue / 100 |
                                        currency:
                                        manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase()
                                        }}</p>
                                    <p class="text-xs/5 text-secondary">{{
                                        manageBriefTabsService.focussedBrief()!.brief_payment_method?.symbol }} {{
                                        getAudiencePricePerVideo(level.bonusValue) |
                                        currency:manageBriefTabsService.focussedBrief()!.currentPrice?.currencyCode?.toUpperCase():'symbol':'1.2-2'
                                        }}</p>
                                </div>
                            </li>
                            }
                        </ul>
                    </div>
                </article>
            </div>
            }
        </div>
        <!-- Pricing Details - END -->

        <!-- Noodle Details -->
        <div *appHasRole="[4,6]" class="w-full flex flex-col gap-y-2 w-full">
            <div class="flex flex-row items-center gap-x-4 w-full py-2">
                <h2 (click)="expandNoodleDetails.set(!expandNoodleDetails())"
                    class="text-sm font-semibold text-primary flex-nowrap min-w-fit hover:cursor-pointer">Noodle Details
                </h2>
                <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
                <button (click)="expandNoodleDetails.set(!expandNoodleDetails())" type="button"
                    class="btn-fab-primary">
                    @if (expandNoodleDetails()) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m18 15-6-6-6 6" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                    }
                </button>
            </div>
            @if (expandNoodleDetails()) {
            <div class="grid gap-x-4">
                <article class="briefing-section-card relative isolate flex flex-col w-full">
                    @if (checkSentToNoodle()) {
                    <div class="rounded-md bg-green-50 p-4 dark:bg-green-500/10 dark:outline dark:outline-green-500/20">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5 text-green-400">
                                    <path
                                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-green-800 dark:text-green-300">Exists in Noodle
                                </p>
                            </div>
                            <div class="ml-auto pl-3">
                                <div class="-mx-1.5 -my-1.5">

                                </div>
                            </div>
                        </div>
                    </div>
                    } @else {
                    <div class="rounded-md bg-red-50 p-4 dark:bg-red-500/10 dark:outline dark:outline-red-500/20">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5 text-red-400">
                                    <path
                                        d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3 flex-1 md:flex md:justify-between">
                                <p class="text-sm text-red-700 dark:text-red-300">Not sent to Noodle!</p>
                                <p class="mt-3 text-sm md:mt-0 md:ml-6">
                                    @if (!sendingToNoodle()) {
                                    <a (click)="sendToNoodle()"
                                        class="font-medium whitespace-nowrap text-blue-700 hover:text-blue-600 dark:text-blue-300 dark:hover:text-blue-200">
                                        Send Now
                                        <span aria-hidden="true"> &rarr;</span>
                                    </a>
                                    } @else {
                                    <span
                                        class="inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium text-gray-900 inset-ring inset-ring-gray-200 dark:text-white dark:inset-ring-white/10">
                                        <svg aria-hidden="true"
                                            class="mx-auto w-5 h-5 text-gray-200 animate-spin dark:text-gray-300 fill-primary"
                                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                                fill="currentColor" />
                                            <path
                                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                                fill="currentFill" />
                                        </svg>

                                        Sending to Noodle...
                                    </span>
                                    }
                                </p>
                            </div>
                        </div>
                    </div>
                    }
                </article>
            </div>
            }
        </div>
        <!-- Noodle Details - END -->

        <!-- Results Type Details -->
        <div *appHasRole="[4,6]" class="w-full flex flex-col gap-y-2 w-full">
            <div class="flex flex-row items-center gap-x-4 w-full py-2">
                <h2 (click)="expandResultsTypeDetails.set(!expandResultsTypeDetails())"
                    class="text-sm font-semibold text-primary flex-nowrap min-w-fit hover:cursor-pointer">Results Type
                    Details
                </h2>
                <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
                <button (click)="expandResultsTypeDetails.set(!expandResultsTypeDetails())" type="button"
                    class="btn-fab-primary">
                    @if (expandResultsTypeDetails()) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m18 15-6-6-6 6" />
                    </svg>
                    } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="size-5">
                        <path d="m6 9 6 6 6-6" />
                    </svg>
                    }
                </button>
            </div>
            @if (expandResultsTypeDetails()) {
            <div class="grid gap-x-4">
                <article class="briefing-section-card relative isolate flex flex-col w-full">
                    @if (manageBriefTabsService.focussedBrief()!.pieces?.length) {
                    <!-- A piece brief has no shout brief: its posts always go through Ultra Social. -->
                    <div
                        class="rounded-md bg-fuchsia-50 p-4 dark:bg-fuchsia-500/10 dark:outline dark:outline-fuchsia-500/20">
                        <div class="flex flex-row items-center justify-start">
                            <div class="shrink-0">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5 text-fuchsia-400">
                                    <path
                                        d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm font-medium text-fuchsia-800 dark:text-fuchsia-300">Ultra Social</p>
                                <p class="text-xs text-fuchsia-700 dark:text-fuchsia-300">Briefs built from pieces always
                                    collect results through Ultra Social.</p>
                            </div>
                        </div>
                    </div>
                    } @else if (manageBriefTabsService.focussedBrief()!.shoutBrief &&
                    manageBriefTabsService.focussedBrief()!.shoutBrief!.resultsVersion) {
                    @switch (manageBriefTabsService.focussedBrief()!.shoutBrief!.resultsVersion) {
                    @case (SubmittedPostVersionEnum.UltraSocial) {
                    <div
                        class="rounded-md bg-fuchsia-50 p-4 dark:bg-fuchsia-500/10 dark:outline dark:outline-fuchsia-500/20">
                        <div class="flex flex-row items-center justify-between gap-4">
                            <div class="flex flex-row items-center justify-start">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-fuchsia-400">
                                        <path
                                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-fuchsia-800 dark:text-fuchsia-300">Ultra Social
                                    </p>
                                </div>
                            </div>
                            <mbt-results-version-select />
                        </div>
                    </div>
                    }
                    @case (SubmittedPostVersionEnum.SuperSocial) {
                    <div class="rounded-md bg-green-50 p-4 dark:bg-green-500/10 dark:outline dark:outline-green-500/20">
                        <div class="flex flex-row items-center justify-between gap-4">
                            <div class="flex flex-row items-center">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-green-400">
                                        <path
                                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-green-800 dark:text-green-300">Super Social</p>
                                </div>
                            </div>
                            <mbt-results-version-select />
                        </div>
                    </div>
                    }
                    @default {
                    <div
                        class="rounded-md bg-yellow-50 p-4 dark:bg-yellow-500/10 dark:outline dark:outline-yellow-500/20">
                        <div class="flex flex-row items-center justify-between gap-4">
                            <div class="flex flex-row items-center">
                                <div class="shrink-0">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5 text-yellow-400">
                                        <path
                                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <p class="text-sm font-medium text-yellow-800 dark:text-yellow-300">Legacy or not
                                        relevant</p>
                                </div>
                            </div>
                            <mbt-results-version-select />
                        </div>
                    </div>
                    }
                    }

                    } @else {
                    <div
                        class="border-l-4 border-yellow-400 bg-yellow-50 p-4 dark:border-yellow-500 dark:bg-yellow-500/10">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                    class="size-5 text-yellow-400 dark:text-yellow-500">
                                    <path
                                        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
                                        clip-rule="evenodd" fill-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm text-yellow-700 dark:text-yellow-300">
                                    Not Applicable.
                                    <a class="font-medium text-yellow-700 underline dark:text-yellow-300">Results
                                        version not applicable for UGC only</a>
                                </p>
                            </div>
                        </div>
                    </div>

                    }
                </article>
            </div>
            }
        </div>
        <!-- Results Type Details - END -->
